import React from 'react'
import { MDXTag } from '@mdx-js/tag'


const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}>{`A few useful Docker commands to build, run and remove docker images/containers`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-sh"
        }}>{`# build 'layer' image using Dockerfile
docker build -t layer -f Dockerfile .

# To run an interactive bash session in a container
docker run -it lambci/lambda:build-python3.7 bash

# run docker image in a detached mode (doesn't wait for command completion)
docker run -d layer false

# remove docker container
docker rm layer

# list all containers (both stopped and running)
docker ps  -a

# remove docker image
docker image rm layer
`}</MDXTag></MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {
  "title": "Useful Docker commands",
  "keywords": "Docker, AWS",
  "menu": "serverless/docker"
};
    